module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Cart1-2a83bf20941597ade51e1e21a6ee1c5f.svg";